module.exports = __webpack_public_path__ + "static/ss9.cdf65b29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/laminardata/ss/ss9.png
// module id = 1172
// module chunks = 112875127094159